// Общий стек модалок для корректной обработки Esc при вложенных окнах.
// Принцип: Esc закрывает только последнее (верхнее) открытое окно.

const OPEN_MODAL_STACK = [];

export const pushModalToStack = (id) => {
  if (!id) return;
  const idx = OPEN_MODAL_STACK.indexOf(id);
  if (idx !== -1) OPEN_MODAL_STACK.splice(idx, 1);
  OPEN_MODAL_STACK.push(id);
};

export const removeModalFromStack = (id) => {
  if (!id) return;
  const idx = OPEN_MODAL_STACK.indexOf(id);
  if (idx !== -1) OPEN_MODAL_STACK.splice(idx, 1);
};

export const isTopModal = (id) =>
  OPEN_MODAL_STACK.length > 0 && OPEN_MODAL_STACK[OPEN_MODAL_STACK.length - 1] === id;

